import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import easyToggle from "easy-toggle-state";

const Header = () => {
	const block = document.querySelector(".header");
	if (!block) {
		return;
	}
	const hasSubItems = block.querySelectorAll(".header__menu-item_has-sub");
	const bg = block.querySelector(".header__bg");
	const aside = block.querySelector(".header__aside");
	const controls = block.querySelector(".header__controls");
	let mm = gsap.matchMedia();
	const panel = document.querySelector(".header__panel");

	if (panel) {
		block.prepend(panel);
		block.classList.add("header_has-panel");
		gsap.registerPlugin(ScrollTrigger);
		const panelHeight = panel.offsetHeight;
		const compStyle = getComputedStyle(panel);

		const tl = gsap.timeline({
			scrollTrigger: {
				trigger: block,
				start: "top top",
				scrub: true,
				onEnter: () => {
					block.classList.add("header_sticky");
				},
				onEnterBack: () => {
					block.classList.remove("header_sticky");
				}
			}
		});
		tl.fromTo(panel,
			{ height: panelHeight, paddingTop: parseInt(compStyle.paddingTop, 10), paddingBottom: parseInt(compStyle.paddingBottom, 10) },
			{ height: 0, paddingTop: 0, paddingBottom: 0, duration: 1 }
		);

		const pageIntro = document.querySelector(".page-intro");
		if (pageIntro) {
			pageIntro.classList.add("page-intro_has-top-offset");
		}
	}

	mm.add("(min-width: 1240px)", () => {
		hasSubItems.forEach(item => {
			item.addEventListener("mouseover", (e) => {
				const sub = e.target.closest(".header__menu-item").querySelector(".header__sub");
				gsap.to(bg, { height: sub.offsetHeight, duration: 0.2 });
			});
		
			item.addEventListener("mouseleave", (e) => {
				gsap.to(bg, { height: 0, duration: 0.2 });
			});
		});
	});

	const clonedControls = controls.cloneNode(true);
	aside.append(clonedControls);
	const clonedToggles = clonedControls.querySelectorAll('[data-toggle-class], [data-toggle-target], [data-toggle-id]');
	if (clonedToggles && clonedToggles.length) {
		clonedToggles.forEach((el) => {
			if (el.hasAttribute("data-toggle-outside")) {
				el.removeAttribute("data-toggle-outside");
			}
		});
		easyToggle(clonedToggles);
	}
	controls.classList.add("header__controls_main");
};

export default Header;
